import Vue from 'vue'

const LoadingInstance = Vue.extend(require('./loading.vue').default);
let instance = null

let getInstance = () => {
  return new LoadingInstance({
    el: document.createElement('div')
  })
}

// let close = () => {
//   instance.close()
//   instance.$el.parentNode.removeChild(instance.$el);
//   instance = null
// }
//
// let Loading = () => {
//   if (instance) {
//     close()
//   }
//   instance = getInstance()
//
//   document.body.appendChild(instance.$el);
//   instance.open()
// }

let Loading = {
  close: () => {
    if (!instance) return
    
    instance.close()
    instance.$el.parentNode.removeChild(instance.$el);
    instance = null
  },
  open: () => {
    if (instance) {
      Loading.close()
    }
    instance = getInstance()

    document.body.appendChild(instance.$el);
    instance.open()
  }
}

export default Loading
